var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAIagent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5567 3.84481C20.4963 3.81725 22.4338 3.84752 24.3692 3.93564C26.7306 4.59098 28.0727 6.13494 28.3955 8.56747C28.4646 11.3437 27.1831 13.1702 24.5508 14.047C24.33 14.0938 24.108 14.1342 23.8848 14.1681C22.1289 14.1882 20.3731 14.2084 18.6172 14.2286C17.7392 15.2761 16.6695 15.5384 15.4082 15.0157C14.7025 14.6234 14.2887 14.0281 14.167 13.2296C14.1266 11.6755 14.1266 10.1215 14.167 8.56747C14.5368 5.96778 16.0001 4.39356 18.5567 3.84481ZM19.041 6.44833C20.5347 6.43822 22.0282 6.44833 23.5215 6.4786C25.0875 6.83359 25.8241 7.81245 25.7315 9.41513C25.4906 10.5036 24.8347 11.1999 23.7637 11.504C21.8479 11.5805 19.9305 11.6209 18.0117 11.6251C17.5522 11.7186 17.1586 11.9305 16.8311 12.2608C16.7907 11.0297 16.7907 9.79857 16.8311 8.56747C17.1307 7.40382 17.8673 6.69742 19.041 6.44833Z",
    fill: "url(#paint0_radial_4236_3480)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0176 8.99121C12.3203 8.99121 12.623 8.99121 12.9258 8.99121C12.9459 9.86 12.9257 10.7278 12.8652 11.5947C10.1803 11.7506 8.23267 13.0221 7.02246 15.4092C5.88766 18.4282 6.52337 21.0014 8.92969 23.1289C9.80943 23.8007 10.7983 24.2245 11.8965 24.4004C13.0855 24.4678 14.2763 24.4981 15.4688 24.4912C16.6612 24.4981 17.852 24.4678 19.041 24.4004C21.4737 23.9251 23.1589 22.5426 24.0967 20.2529C24.2875 19.6822 24.4086 19.097 24.46 18.4971C24.4902 17.4882 24.5003 16.479 24.4902 15.4697C25.3581 15.4697 26.2259 15.4697 27.0938 15.4697C27.0938 15.8936 27.0938 16.3174 27.0938 16.7412C27.5377 16.7412 27.9818 16.7412 28.4258 16.7412C28.4258 17.609 28.4258 18.4769 28.4258 19.3447C27.9616 19.3447 27.4974 19.3447 27.0332 19.3447C26.2648 23.3928 23.8833 25.9256 19.8887 26.9434C19.6272 26.9894 19.3648 27.0298 19.1016 27.0645C16.6797 27.1048 14.2578 27.1048 11.8359 27.0645C8.30496 26.5195 5.83261 24.6122 4.41895 21.3428C4.18082 20.693 4.00927 20.027 3.9043 19.3447C3.4401 19.3447 2.97591 19.3447 2.51172 19.3447C2.51172 18.4769 2.51172 17.609 2.51172 16.7412C2.97591 16.7412 3.4401 16.7412 3.9043 16.7412C4.45152 13.6158 6.12667 11.3251 8.92969 9.86914C9.92096 9.41468 10.9503 9.12205 12.0176 8.99121Z",
    fill: "url(#paint1_radial_4236_3480)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.946,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2298 16.7409C12.5887 16.717 13.1033 17.3629 12.7737 18.6784C12.2536 19.3874 11.5977 19.5387 10.806 19.1325C10.1975 18.5737 10.1067 17.938 10.5335 17.2252C10.7443 17.0231 10.9764 16.8616 11.2298 16.7409Z",
    fill: "url(#paint2_radial_4236_3480)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.946,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9798 16.7409C20.3387 16.717 20.8533 17.3629 20.5237 18.6784C20.0036 19.3874 19.3477 19.5387 18.556 19.1325C17.9475 18.5737 17.8567 17.938 18.2835 17.2252C18.4943 17.0231 18.7264 16.8616 18.9798 16.7409Z",
    fill: "url(#paint3_radial_4236_3480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4236_3480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2674 9.55585) rotate(90) scale(5.72088 7.13073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E35B1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E35B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4236_3480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4688 18.043) rotate(90) scale(9.05177 12.957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E35B1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E35B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4236_3480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5699 18.0473) rotate(90) scale(1.30712 1.30035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E35B1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E35B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4236_3480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3199 18.0473) rotate(90) scale(1.30712 1.30035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E35B1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E35B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIagent);
export default __webpack_public_path__ + "static/media/AI agent.ab77b3a9cd2829a632472f6668021118.svg";
export { ForwardRef as ReactComponent };